import React, {useState} from "react";
import {
  Grid,
  Avatar,
  Button,
} from "@material-ui/core";
import { CSVLink, CSVDownload } from "react-csv";

import { useProfilesContext } from "../../context/ProfilesContext";

import { useProfileContext } from "../../context/ProfileContext";

// styles
import useStyles from "./styles";

// components
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import Loading from "../../components/Loading/Loading";

export default function Dashboard(props) {
  var classes = useStyles();
  var profiles = useProfilesContext().profiles;
  var Profile = useProfileContext();
  var LoadingScreen = useProfilesContext().loading;

  const navigateToProfile = (profile) => {
    Profile.setCurrentProfile(profile)
    props.history.push(`/app/${profile}/profile`)
  }

  const headers = [
    { label: "Email", key: "email" },
    { label: "Name", key: "name" },
    { label: "Survey Completed", key: "surveyCompleted" },
    { label: "Question 1: Email Address", key: "survey.email" },
    { label: "Question 2: Name/Contact", key: "survey.name" },
    { label: "Question 3: Company", key: "survey.company" },
    { label: "Question 4: Sector/Industry", key: "survey.industry" },
    { label: "Question 5: Phone", key: "survey.phone" },
    { label: "Question 6: The corporate RE function has a clearly defined mission of contributing earnings to the enterprise?", key: "survey.mission" },
    { label: "Question 7: There is untapped potential in the Company's RE assets for cost savings and new earnings.", key: "survey.potential" },
    { label: "Question 8: The Company is operating at a 'best practices' level with respect to cost reduction strategies for real estate operating expenses and space utilization.", key: "survey.bestPractices" },
    { label: "Question 9: The Company has established Key Performance Indicator's (KPI's) for measuring RE's contribution to the success of the enterprise.", key: "survey.kpi" },
    { label: "Question 10: The Company has a proactive strategy for disposition of excess property and leased space.", key: "survey.disposition" },
    { label: "Question 11: The Company is aggressively executing the disposition process.", key: "survey.aggressive" },
    { label: "Question 12: The company uses NRV (net realizable value) models that assist in space strategy and financial decision making", key: "survey.nrv" },
    { label: "Question 13: Does the Company's RE portfolio tie into the ERP system?", key: "survey.erpSystem" },
    { label: "Question 14: The Company has the ability to breakout financials for RE occupancy costs.", key: "survey.breakoutFinancials" },
    { label: "Question 15: If the Company runs SAP or Oracle - Is the RE module currently activated?", key: "survey.REModule" },
    { label: "Question 16: What are the barriers to optimizing real estate assets in your enterprise?", key: "survey.challenges" }, 
  ];

  if (LoadingScreen) {
    return(
    <Loading />
    )
  }

  return (
    <>
      <div className={classes.profileTitle}>
        <PageTitle title="Profiles" />
        <div className={classes.data}>
          {profiles && profiles.length > 0 && (
            <CSVLink className={classes.CSVLink} headers={headers} data={profiles} filename="CREEDProfiles.csv">
              {/*<button>Download User Profiles</button>*/}
              <Button variant="contained" size="medium" color="Primary">Export Profiles</Button>
          </CSVLink>
          )}
        </div>  
      </div>
      <Grid container spacing={4}>
        {profiles?.map((profile) => {
          if(profile.id !== localStorage.getItem('user_uid')) {
              return(
                <Grid item lg={3} md={8} sm={6} xs={12}>
                  <Widget
                    title={profile.name}
                    upperTitle
                    className={classes.card}
                    bodyClass={classes.fullHeightBody}
                  >
                    <div className={classes.performanceLegendWrapper}>
                      <div className={classes.legendElement}>
                        <Typography
                          color="text"
                          colorBrightness="secondary"
                        >
                          {profile.email}
                        </Typography>
                      </div>
                    </div>
                    <div className={classes.progressSection}>
                      {profile.avatar ? 
                      <Avatar src={'data:image/png;base64,' + profile.avatar} className={classes.large} />
                      : <Avatar className={classes.large} />}
                    </div>
                    <Button size="small" color="primary" onClick={() => navigateToProfile(profile.id)}>View</Button>
                  </Widget>
                </Grid>
              )
            }
          })}
      </Grid>
    </>
  );
}
